import { createFileRoute } from '@tanstack/react-router';

import { GridEditorPage } from '@/pages/grid-editor/grid-editor-page';

export const Route = createFileRoute('/grid-editor/$diagramId')({
    component: GridEditorRoute,
    // The page-level EditorHeaderTray owns both corners on desktop: app nav
    // in its left end, account corner in its right end.
    staticData: { ownTopLeft: true, ownTopRight: true },
});

function GridEditorRoute() {
    const { diagramId } = Route.useParams();
    return <GridEditorPage diagramId={diagramId} />;
}
